import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import { XTokenModule } from '@/store/modules/XTokenModule';
import moment from 'moment';
import Func from '@/views/pscm/requisition/functionhelpers.js';
import * as bootstrap from 'bootstrap';
import store from '@/store';
import { hideModal } from '@/core/helpers/dom';
let CrfModule = class CrfModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.isOnImport = false;
        this.isSuccessImported = false;
        this.isGenerateClicked = false;
        this.isSubmitError = {
            conditions: false,
            message: '',
            isField: null
        };
        this.isAllowSubmit = true;
        this.isShowErrorDialog = false;
        this.historiesRevise = [];
        this.isFirstTouch = true;
        this.runWorkFlowID = null;
        this.importFileCrf = {
            files: null,
            store: [],
            isError: false,
            isImported: false,
            isAllowImport: true,
            isOnAsync: false
        };
        this.summaryBudget = {
            value: '',
            isTouched: false
        };
        this.picProcurement = {
            picprcSpendingValueCurrency: '',
            picprcSpendingValue: '',
            picprcVendorName: '',
            picprcPeriode: ''
        };
        this.isSubmitClicked = false;
        this.isDraftJci = false;
        this.isDraftFpk = false;
        this.isHo6 = false;
        this.submitDialog = false;
        this.successDialog = false;
        this.submitInfoDialog = false;
        this.discardDialog = false;
        this.importDialog = false;
        this.importCondition = 'crf';
        this.isLoading = false;
        this.isDraft = false;
        this.xtokenModule = '';
        this.detailArrayJci = {};
        this.detailArrayFpk = {};
        this.detailUser = {};
        this.lookupFunction = [];
        this.lookupJenisPekerjaan = [];
        this.lookupPicProcurement = [];
        this.brrfFiles = [];
        this.tabConditions = '';
        this.lookupKebutuhanPekerjaan = [];
        this.lookupLokasi = [];
        this.lookupLokasiPengiriman = [];
        this.lookupPlant = [];
        this.usdRate = '';
        this.idrRate = '';
        this.lookupUom = [];
        this.lookupUomPayung = [];
        this.lookupRiskAssessment = [];
        this.fieldSecuritySettings = {
            allowEdit: '',
            allowView: ''
        };
        this.requestorSettings = {
            requestorLevelID: '',
            requestorLocationID: ''
        };
        this.tabAdditional = {
            riskAssessment: '',
            AdditionalInformation: '',
            isAdditionalInformationTouched: false,
            remarks: '',
            scopeOfWorkFiles: [],
            isScopeOfWorkTouched: false,
            perizinanKhususFiles: [],
            structureCostFiles: [],
            isStructureCostTouched: false,
            slaFiles: [],
            isSlaTouched: false,
            riskAssessmentFiles: [],
            keteranganTambahanFiles: [],
            isKeteranganTambahanTouched: false,
            ibprFiles: [],
            isSubmitClicked: false,
            isComplete: ''
        };
        this.tabCrf = {
            crfNo: '',
            jobTypeID: null,
            jobTypeDescription: '',
            isJobTypeTouched: false,
            community: null,
            isCommunityTouched: false,
            expenditure: '',
            isExpenditureTouched: false,
            transaksiBulky: null,
            isTransaksiBulkyTouched: false,
            brrfFiles: [],
            isBrrfTouched: false,
            function: '',
            isFunctionTouched: false,
            isSubmitClicked: false,
            isComplete: ''
        };
        this.tabRkk = {
            picProcurementName: '',
            tanggalCrfDibuat: '',
            crfCreatedDate: [],
            isCrfCreatedDateTouched: false,
            contractPeriod: '',
            kebutuhanPekerjaan: '',
            isKebutuhanPekerjaanTouched: false,
            previousContractNo: '',
            isPreviousContractNoTouched: false,
            isExtension: null,
            isExtensionTouched: false,
            extensionPeriod: '',
            isExtensionPeriodTouched: false,
            picProcurementID: '',
            isPicProcurementIDTouched: false,
            isSubmitClicked: false,
            isComplete: ''
        };
        this.tabLocationUser = [];
        this.isTabLocationUserTouched = false;
        this.tabLocationDelivery = [];
        this.isTabLocationDeliveryTouched = false;
        this.locationComplete = '';
        this.isSubmitLocationClicked = false;
        this.lookupPersons = [];
        // Form Data
        this.rincianInformasiArray = [
            {
                uom: '',
                isUomTouched: false,
                description: '',
                isDeskripsiTouched: false,
                currency: '',
                isCurrencyTouched: false,
                exchangeRate: '',
                estimasiBiaya: '',
                isEstimasiBiayaTouched: false,
                isSaved: false,
                quantity: '',
                isQuantityTouched: false,
                plantID: '',
                isPlantTouched: false,
                crfCreatedDate: [],
                isCrfCreatedDateTouched: false,
                periode: '',
                isIndexEdit: false,
                listSubItems: [],
                isSaveClicked: false,
                rentalType: '',
                isRentalTouched: false,
                mutationQuantity: null,
                isMutationQuantityTouched: false,
                newOrderQuantity: null,
                mutationFrom: '',
                isMutationFromTouched: false
            }
        ];
        this.isRincianInfoError = false;
        this.lookupVendor = [];
        this.lookupPicProc = [];
        this.workflowFirstLand = true;
        this.workflowDataStore = [];
        this.tabTypeFirstLand = true;
        this.draftClick = '';
        this.isDraftClicked = false;
        this.listError = {
            tabCrf: [],
            tabRkk: [],
            tabLokasi: [],
            tabRincianInformasi: [],
            tabAdditionalInfo: []
        };
        this.errorDownloadTemplate = {};
        this.errorImportTemplate = {};
        this.submitClick = false;
        this.buttonIsDraftChange = false;
        this.submitInfoMessage = '';
        this.afterCallApi = false;
        this.rincianInfoAllComplete = false;
        this.isShowMessageRincianInfo = false;
        this.conversation = {};
        this.jobTypeLabel = '';
        this.isDraftChange = false;
        this.expenditureType = null;
        this.generalOptionsUOM = [];
        this.generalOptionsPlant = [];
        this.formComment = {
            comment: '',
            isLoading: false
        };
    }
    get getSubmitInfoMessage() {
        return this.submitInfoMessage;
    }
    ['setSubmitInfoMessage'](data) {
        this.submitInfoMessage = data;
    }
    get getButtonIsDraftChange() {
        return this.buttonIsDraftChange;
    }
    get getIsAllowSubmitCrf() {
        return this.isAllowSubmit;
    }
    get getErrorDownloadTemplate() {
        return this.errorDownloadTemplate;
    }
    ['setErrorDownloadTemplate'](data) {
        this.errorDownloadTemplate = data;
    }
    get getErrorImportTemplate() {
        return this.errorImportTemplate;
    }
    ['setErrorImportTemplate'](data) {
        this.errorImportTemplate = data;
    }
    ['setIsAllowSubmitCrf'](data) {
        this.isAllowSubmit = data;
    }
    ['setButtonIsDraftChange'](data) {
        this.buttonIsDraftChange = data;
    }
    get getDraftClick() {
        return this.draftClick;
    }
    ['setIsDraftClick'](data) {
        this.draftClick = data;
    }
    get getIsDraftClicked() {
        return this.isDraftClicked;
    }
    ['setIsDraftClicked'](data) {
        this.isDraftClicked = data;
    }
    get getTabTypeFirstLand() {
        return this.tabTypeFirstLand;
    }
    ['setTabTypeFirstLand'](data) {
        this.tabTypeFirstLand = data;
    }
    get getWorkflowFirstLand() {
        return this.workflowFirstLand;
    }
    get getWorkflowDataStore() {
        return this.workflowDataStore;
    }
    ['setWorkflowFirstLand'](data) {
        this.workflowFirstLand = data;
    }
    ['setWorkflowDataStore'](data) {
        this.workflowDataStore = data;
    }
    get getShowErrorDialog() {
        return this.isShowErrorDialog;
    }
    get getIsFirstTouch() {
        return this.isFirstTouch;
    }
    get getLookUpVendor() {
        return this.lookupVendor;
    }
    get getLookUpPicProc() {
        return this.lookupPicProc;
    }
    get getIsDraft() {
        return this.isDraft;
    }
    get getRincianInfoValidation() {
        return this.isRincianInfoError;
    }
    get getTabCrf() {
        return this.tabCrf;
    }
    get getPicProcurement() {
        return this.picProcurement;
    }
    get getSummaryBudget() {
        return this.summaryBudget;
    }
    get getIsSubmitClicked() {
        return this.isSubmitClicked;
    }
    get getIsSubmitLocationClicked() {
        return this.isSubmitLocationClicked;
    }
    get getLocationComplete() {
        return this.locationComplete;
    }
    get getTabAdditionalCompletion() {
        this.tabAdditional.isSubmitClicked = true;
        let returnValue;
        if (this.tabAdditional.scopeOfWorkFiles.length == 0 ||
            this.tabAdditional.slaFiles.length == 0) {
            this.tabAdditional.isComplete = 'Not complete';
            returnValue = false;
        }
        else if (this.tabAdditional.scopeOfWorkFiles.length != 0 &&
            this.tabAdditional.slaFiles.length != 0) {
            this.tabAdditional.isComplete = 'Complete';
            returnValue = true;
        }
        return returnValue;
    }
    get getTabAdditionalCompletionWatcher() {
        let returnValue;
        if (this.tabAdditional.scopeOfWorkFiles.length == 0 ||
            this.tabAdditional.structureCostFiles.length == 0 ||
            this.tabAdditional.slaFiles.length == 0) {
            this.tabAdditional.isComplete = 'Not complete';
            returnValue = false;
        }
        else if (this.tabAdditional.scopeOfWorkFiles.length != 0 &&
            this.tabAdditional.structureCostFiles.length != 0 &&
            this.tabAdditional.slaFiles.length != 0) {
            this.tabAdditional.isComplete = 'Complete';
            returnValue = true;
        }
        return returnValue;
    }
    get getCrfCompletion() {
        this.tabCrf.isSubmitClicked = true;
        let returnValue;
        if (this.tabCrf.jobTypeID == '' ||
            this.tabCrf.jobTypeID == null ||
            this.tabCrf.community == null ||
            this.tabCrf.expenditure == '' ||
            this.tabCrf.expenditure == null ||
            this.tabCrf.brrfFiles.length == 0 ||
            this.tabCrf.transaksiBulky == null ||
            this.tabCrf.function == '' ||
            this.tabCrf.function == null) {
            this.tabCrf.isComplete = 'Not complete';
            returnValue = false;
        }
        else if (((this.tabCrf.jobTypeID != '' || this.tabCrf.jobTypeID != null) &&
            this.tabCrf.community != null &&
            (this.tabCrf.expenditure != '' || this.tabCrf.expenditure != null) &&
            this.tabCrf.brrfFiles.length != 0) ||
            (this.tabCrf.transaksiBulky != null &&
                (this.tabCrf.function != '' || this.tabCrf.function != null))) {
            this.tabCrf.isComplete = 'Complete';
            returnValue = true;
        }
        return returnValue;
    }
    get getCrfCompletionWatcher() {
        let returnValue;
        if (this.tabCrf.jobTypeID == '' ||
            this.tabCrf.jobTypeID == null ||
            this.tabCrf.community == null ||
            this.tabCrf.expenditure == '' ||
            this.tabCrf.expenditure == null ||
            (this.tabCrf.expenditure == 'CAPEX' &&
                this.tabCrf.brrfFiles.length == 0) ||
            this.tabCrf.transaksiBulky == null ||
            this.tabCrf.function == '' ||
            this.tabCrf.function == null) {
            this.tabCrf.isComplete = 'Not complete';
            returnValue = false;
        }
        else if ((this.tabCrf.jobTypeID != '' || this.tabCrf.jobTypeID != null) &&
            this.tabCrf.community != null &&
            (this.tabCrf.expenditure != '' || this.tabCrf.expenditure != null) &&
            this.tabCrf.transaksiBulky != null &&
            (this.tabCrf.function != '' || this.tabCrf.function != null)) {
            this.tabCrf.isComplete = 'Complete';
            returnValue = true;
        }
        return returnValue;
    }
    get getRkkCompletion() {
        this.tabRkk.isSubmitClicked = true;
        let returnValue;
        if (this.tabRkk.crfCreatedDate[0] == undefined ||
            this.tabRkk.kebutuhanPekerjaan == null ||
            this.tabRkk.kebutuhanPekerjaan == '' ||
            (this.tabRkk.kebutuhanPekerjaan == 'Addendum' &&
                this.tabRkk.previousContractNo == '') ||
            this.tabRkk.isExtension == null ||
            (this.tabRkk.isExtension && this.tabRkk.extensionPeriod == '') ||
            this.tabRkk.picProcurementID == '' ||
            this.tabRkk.picProcurementID == null) {
            this.tabRkk.isComplete = 'Not complete';
            returnValue = false;
        }
        else if (this.tabRkk.crfCreatedDate[0] != undefined &&
            (this.tabRkk.kebutuhanPekerjaan != null ||
                this.tabRkk.kebutuhanPekerjaan != '') &&
            this.tabRkk.isExtension != null &&
            (this.tabRkk.picProcurementID != '' ||
                this.tabRkk.picProcurementID != null)) {
            this.tabRkk.isComplete = 'Complete';
            returnValue = true;
        }
        return returnValue;
    }
    get getRkkCompletionWatcher() {
        let returnValue;
        if (this.tabRkk.crfCreatedDate[0] == undefined ||
            this.tabRkk.kebutuhanPekerjaan == null ||
            this.tabRkk.kebutuhanPekerjaan == '' ||
            (this.tabRkk.kebutuhanPekerjaan == 'Addendum' &&
                this.tabRkk.previousContractNo == '') ||
            this.tabRkk.isExtension == null ||
            (this.tabRkk.isExtension && this.tabRkk.extensionPeriod == '') ||
            this.tabRkk.picProcurementID == '' ||
            this.tabRkk.picProcurementID == null) {
            this.tabRkk.isComplete = 'Not complete';
            returnValue = false;
        }
        else if (this.tabRkk.crfCreatedDate[0] != undefined &&
            (this.tabRkk.kebutuhanPekerjaan != null ||
                this.tabRkk.kebutuhanPekerjaan != '') &&
            this.tabRkk.isExtension != null &&
            (this.tabRkk.picProcurementID != '' ||
                this.tabRkk.picProcurementID != null)) {
            this.tabRkk.isComplete = 'Complete';
            returnValue = true;
        }
        return returnValue;
    }
    get getLocationCompletion() {
        let returnValue;
        if (this.tabLocationUser.length == 0 ||
            this.tabLocationDelivery.length == 0) {
            returnValue = false;
        }
        else if (this.tabLocationUser.length != 0 &&
            this.tabLocationDelivery.length != 0) {
            returnValue = true;
        }
        return returnValue;
    }
    get getLocationCompletionWatcher() {
        let returnValue;
        if (this.tabLocationUser.length == 0 ||
            this.tabLocationDelivery.length == 0) {
            returnValue = false;
        }
        else if (this.tabLocationUser.length != 0 &&
            this.tabLocationDelivery.length != 0) {
            returnValue = true;
        }
        return returnValue;
    }
    get getRincianInformasiArrayCompletion() {
        let found = true;
        for (let i = 0; i < this.rincianInformasiArray.length; i++) {
            const dataItem = this.rincianInformasiArray[i];
            if (!dataItem.isSaved) {
                found = false;
                dataItem.isSaveClicked = true;
            }
            for (let s = 0; s < dataItem.listSubItems.length; s++) {
                const dataSub = dataItem.listSubItems[s];
                dataSub.isCodeTouched = true;
                dataSub.isDescriptionTouched = true;
                dataSub.isQuantityTouched = true;
                dataSub.isUomTouched = true;
            }
        }
        return found;
    }
    get getAfterCallApiCrf() {
        return this.afterCallApi;
    }
    ['setAfterCallApiCrf'](data) {
        this.afterCallApi = data;
    }
    get getRincianInfoAllComplete() {
        return this.rincianInfoAllComplete;
    }
    get getIsShowMessageRincianInfoCrf() {
        return this.isShowMessageRincianInfo;
    }
    ['setShowMessageRincianInfoCrf'](data) {
        this.isShowMessageRincianInfo = data;
    }
    ['setRincianInfoAllComplete'](data) {
        let counted = 0;
        this.rincianInformasiArray.forEach((_e, index) => {
            var _a;
            const dataIndex = this.rincianInformasiArray[index];
            const biaya = (_a = dataIndex.estimasiBiaya) === null || _a === void 0 ? void 0 : _a.split(',');
            const merged = biaya === null || biaya === void 0 ? void 0 : biaya.join('');
            const isMoreThanZero = merged > 0.0;
            let completion;
            if (dataIndex.description == '' ||
                dataIndex.description == null ||
                dataIndex.currency == '' ||
                dataIndex.currency == null ||
                dataIndex.estimasiBiaya == '' ||
                dataIndex.estimasiBiaya == null ||
                !isMoreThanZero ||
                dataIndex.quantity == '' ||
                dataIndex.quantity == null ||
                dataIndex.plantID == '' ||
                dataIndex.plantID == null ||
                dataIndex.uom == '' ||
                dataIndex.uom == null ||
                dataIndex.crfCreatedDate == '' ||
                dataIndex.crfCreatedDate[0] == null) {
                completion = false;
            }
            else {
                if (dataIndex.listSubItems.length == 0) {
                    completion = true;
                }
                else {
                    for (const i of dataIndex.listSubItems) {
                        if (i.description == '' ||
                            i.description == null ||
                            i.quantity == '' ||
                            i.quantity == null ||
                            i.uom == '' ||
                            i.uom == null ||
                            (data.isRental &&
                                !data.budgetByPicProc &&
                                (i.code == '' || i.code == null))) {
                            completion = false;
                            break;
                        }
                        else {
                            completion = true;
                        }
                    }
                }
                if (data.isAllowEditMF &&
                    !data.isDisabled &&
                    !data.onlyCreator &&
                    !data.budgetByPicProc) {
                    if (dataIndex.rentalType == '' ||
                        dataIndex.rentalType == null ||
                        ((dataIndex.mutationQuantity == '' ||
                            dataIndex.mutationQuantity == null) &&
                            dataIndex.rentalType.toLowerCase() == 'mutasi') ||
                        ((dataIndex.mutationFrom == '' || dataIndex.mutationFrom == null) &&
                            dataIndex.rentalType.toLowerCase() == 'mutasi')) {
                        completion = false;
                    }
                }
            }
            if (data.isRental &&
                !data.budgetByPicProc &&
                dataIndex.listSubItems.length == 0) {
                completion = false;
            }
            if (completion)
                counted++;
            dataIndex.isSaveClicked = true;
            dataIndex.isSaved = completion;
        });
        if (counted < this.rincianInformasiArray.length &&
            !data.onlyCreator &&
            !data.budgetByPicProc)
            this.isShowMessageRincianInfo = true;
    }
    get getHistoriesRevise() {
        return this.historiesRevise;
    }
    get getTabRkk() {
        return this.tabRkk;
    }
    get getTabLocationUser() {
        return this.tabLocationUser;
    }
    get getTabLocationDelivery() {
        return this.tabLocationDelivery;
    }
    get getIsTabLocationUserTouched() {
        return this.isTabLocationUserTouched;
    }
    get getIsTabLocationDeliveryTouched() {
        return this.isTabLocationDeliveryTouched;
    }
    get getXTokenModule() {
        return this.xtokenModule;
    }
    get getDetailJci() {
        return this.detailArrayJci;
    }
    get getDetailFpk() {
        return this.detailArrayFpk;
    }
    get getFieldSecuritySettings() {
        return this.fieldSecuritySettings;
    }
    get getRequestorSettings() {
        return this.requestorSettings;
    }
    get getDetailUser() {
        return this.detailUser;
    }
    get getIsLoading() {
        return this.isLoading;
    }
    get getLookUpFunctionCrf() {
        return this.lookupFunction;
    }
    get getLookUpJenisPekerjaanCrf() {
        return this.lookupJenisPekerjaan;
    }
    get getTabConditions() {
        return this.tabConditions;
    }
    get getLookUpKebutuhanPekerjaan() {
        return this.lookupKebutuhanPekerjaan;
    }
    get getLookUpPicProcurement() {
        return this.lookupPicProcurement;
    }
    get getBrrfFiles() {
        return this.brrfFiles;
    }
    get getLookupLokasi() {
        return this.lookupLokasi;
    }
    get getLookupLokasiPengiriman() {
        return this.lookupLokasiPengiriman;
    }
    get getLookupPlant() {
        return this.lookupPlant;
    }
    get getUSDRate() {
        return this.usdRate;
    }
    get getIDRRate() {
        return this.idrRate;
    }
    get getLookupUom() {
        return this.lookupUom;
    }
    get getLookupUomPayung() {
        return this.lookupUomPayung;
    }
    get getLookupRiskAssessment() {
        return this.lookupRiskAssessment;
    }
    get getRincianInformasiArray() {
        return this.rincianInformasiArray;
    }
    get getTabAdditional() {
        return this.tabAdditional;
    }
    get getLookupPersons() {
        return this.lookupPersons;
    }
    get getSubmitDialog() {
        return this.submitDialog;
    }
    get getSuccessDialog() {
        return this.successDialog;
    }
    get getSubmitInfoDialog() {
        return this.submitInfoDialog;
    }
    get getDiscardDialog() {
        return this.discardDialog;
    }
    get getImportDialog() {
        return this.importDialog;
    }
    get getImportConditionDialog() {
        return this.importCondition;
    }
    get getimportFileCrf() {
        return this.importFileCrf;
    }
    get getIsDraftJci() {
        return this.isDraftJci;
    }
    get getIsDraftFpk() {
        return this.isDraftFpk;
    }
    get getIsHo6() {
        return this.isHo6;
    }
    get getErrorTabCrf() {
        return this.listError.tabCrf;
    }
    get getErrorTabRkk() {
        return this.listError.tabRkk;
    }
    get getErrorTabLokasi() {
        return this.listError.tabLokasi;
    }
    get getErrorTabRincianInformasi() {
        return this.listError.tabRincianInformasi;
    }
    get getErrorTabAdditionalInfo() {
        return this.listError.tabAdditionalInfo;
    }
    get getSubmitClick() {
        return this.submitClick;
    }
    get getAccessCrf() {
        return this.detailUser.access || [];
    }
    ['setRincianInfoError'](data) {
        this.isRincianInfoError = data;
    }
    ['setShowErrorDialog'](data) {
        this.isShowErrorDialog = data;
    }
    ['setRunWorkFlowID'](data) {
        this.runWorkFlowID = data;
    }
    ['setIsFirstTouch'](data) {
        this.isFirstTouch = data;
    }
    ['setIsSubmitClicked'](data) {
        this.isSubmitClicked = data;
    }
    ['setIsDraftJci'](data) {
        this.isDraftJci = data;
    }
    ['setIsDraftFpk'](data) {
        this.isDraftFpk = data;
    }
    ['setIsDraft'](data) {
        this.isDraft = data;
    }
    ['setIsSubmitLocationClicked'](data) {
        this.isSubmitLocationClicked = data;
    }
    ['setIsLocationTabUser'](data) {
        this.isTabLocationUserTouched = data;
    }
    ['setIsLocationTabDelivery'](data) {
        this.isTabLocationDeliveryTouched = data;
    }
    ['setLocationComplete'](data) {
        this.locationComplete = data;
    }
    ['addLocationUser'](data) {
        this.tabLocationUser.push(data);
    }
    ['ReplaceLocationUser'](data) {
        this.tabLocationUser = [];
        this.tabLocationUser.push(data);
    }
    ['addLocationDelivery'](data) {
        this.tabLocationDelivery.push(data);
    }
    ['ReplaceLocationDelivery'](data) {
        const newArray = [];
        this.tabLocationDelivery.forEach((element, index) => {
            switch (element.locationID) {
                case '4':
                    newArray.push(this.tabLocationDelivery[index]);
                    break;
                case '5':
                    newArray.push(this.tabLocationDelivery[index]);
            }
        });
        newArray.push(data);
        this.tabLocationDelivery = [];
        this.tabLocationDelivery = newArray;
    }
    ['setContractPeriod'](data) {
        this.tabRkk.contractPeriod = data;
    }
    ['setXtokenModule'](data) {
        this.xtokenModule = data;
    }
    ['setDetailJci'](data) {
        this.detailArrayJci = data;
    }
    ['setDetailFpk'](data) {
        this.detailArrayFpk = data;
    }
    ['setLookUpVendor'](data) {
        this.lookupVendor = data;
    }
    ['setLookUpPicProc'](data) {
        this.lookupPicProc = data;
    }
    ['setDetailUser'](data) {
        this.detailUser = data;
    }
    ['setLookUpFunction'](data) {
        this.lookupFunction = data;
    }
    ['setLookUpJenisPekerjaan'](data) {
        this.lookupJenisPekerjaan = data;
    }
    ['setBrrfFilesClear']() {
        this.brrfFiles = [];
    }
    ['setBrrfFiles'](data) {
        this.tabCrf.brrfFiles.push(data);
    }
    ['setFilesScopeOfWorkClear']() {
        this.tabAdditional.scopeOfWorkFiles = [];
    }
    ['setFilesScopeOfWork'](data) {
        this.tabAdditional.scopeOfWorkFiles.push(data);
    }
    ['setFilesPerizinanKhususClear']() {
        this.tabAdditional.perizinanKhususFiles = [];
    }
    ['setFilesPerizinanKhusus'](data) {
        this.tabAdditional.perizinanKhususFiles.push(data);
    }
    ['setHistoriesRevise'](data) {
        this.historiesRevise = data;
    }
    ['setFilesStructureCostClear']() {
        this.tabAdditional.structureCostFiles = [];
    }
    ['setFilesStructureCost'](data) {
        this.tabAdditional.structureCostFiles.push(data);
    }
    ['setFilesSlaClear']() {
        this.tabAdditional.slaFiles = [];
    }
    ['setFilesSla'](data) {
        this.tabAdditional.slaFiles.push(data);
    }
    ['setFilesRiskAssessmentClear']() {
        this.tabAdditional.riskAssessmentFiles = [];
    }
    ['setFilesRiskAssessment'](data) {
        this.tabAdditional.riskAssessmentFiles.push(data);
    }
    ['setFilesKeteranganTambahanClear']() {
        this.tabAdditional.keteranganTambahanFiles = [];
    }
    ['setFilesKeteranganTambahan'](data) {
        this.tabAdditional.keteranganTambahanFiles.push(data);
    }
    ['setFilesIbprClear']() {
        this.tabAdditional.ibprFiles = [];
    }
    ['setFilesIbpr'](data) {
        this.tabAdditional.ibprFiles.push(data);
    }
    ['setIsLoading'](data) {
        this.isLoading = data;
    }
    ['setTabConditions'](data) {
        this.tabConditions = data;
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    ['setLookUpKebutuhanPekerjaan'](data) {
        this.lookupKebutuhanPekerjaan = data;
    }
    ['setLookUpPicProcurement'](data) {
        this.lookupPicProcurement = data;
    }
    ['setLookUpLokasi'](data) {
        this.lookupLokasi = data;
    }
    ['setLookUpLokasiPengiriman'](data) {
        this.lookupLokasiPengiriman = data;
    }
    ['setLookUpPlant'](data) {
        this.lookupPlant = data;
    }
    ['setUSDRate'](data) {
        this.usdRate = data;
    }
    ['setIDRRate'](data) {
        this.idrRate = data;
    }
    ['setLookUpUom'](data) {
        this.lookupUom = data;
    }
    ['setLookUpUomPayung'](data) {
        this.lookupUomPayung = data;
    }
    ['setLookUpRiskAssessment'](data) {
        this.lookupRiskAssessment = data;
    }
    ['setLookupPerson'](data) {
        this.lookupPersons = data;
    }
    ['pushRincianInformasiArray']() {
        this.rincianInformasiArray.push({
            uom: '',
            isUomTouched: false,
            description: '',
            isDeskripsiTouched: false,
            currency: '',
            isCurrencyTouched: false,
            exchangeRate: '',
            estimasiBiaya: '',
            isEstimasiBiayaTouched: false,
            isSaved: false,
            quantity: '',
            isQuantityTouched: false,
            plantID: '',
            isPlantTouched: false,
            crfCreatedDate: [],
            isCrfCreatedDateTouched: false,
            periode: '',
            isIndexEdit: false,
            listSubItems: [],
            isSaveClicked: false,
            rentalType: '',
            isRentalTouched: false,
            mutationQuantity: null,
            isMutationQuantityTouched: false,
            newOrderQuantity: null,
            mutationFrom: '',
            isMutationFromTouched: false
        });
        setTimeout(function () {
            window.scrollTo({
                top: document.body.scrollHeight,
                behavior: 'smooth'
            });
        }, 50);
    }
    ['editIndexRincian'](data) {
        var _a, _b;
        if (data.conditions == 'subItems') {
            this.rincianInformasiArray[data.index].listSubItems.push({
                description: '',
                isDescriptionTouched: false,
                quantity: '',
                isQuantityTouched: false,
                uom: '',
                isUomTouched: false,
                code: '',
                isCodeTouched: false,
                additionalCode: '',
                remarks: ''
            });
        }
        else if (data.conditions == 'save') {
            const dataIndex = this.rincianInformasiArray[data.index];
            let biaya = ((_a = dataIndex.estimasiBiaya.toString()) === null || _a === void 0 ? void 0 : _a.includes(',')) ? dataIndex.estimasiBiaya
                : dataIndex.estimasiBiaya
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            biaya = (_b = dataIndex.estimasiBiaya.toString()) === null || _b === void 0 ? void 0 : _b.split(',');
            const merged = biaya === null || biaya === void 0 ? void 0 : biaya.join('');
            const isMoreThanZero = merged > 0.0;
            let completion;
            if (dataIndex.description == '' ||
                dataIndex.description == null ||
                dataIndex.currency == '' ||
                dataIndex.currency == null ||
                dataIndex.estimasiBiaya == '' ||
                dataIndex.estimasiBiaya == null ||
                !isMoreThanZero ||
                dataIndex.quantity == '' ||
                dataIndex.quantity == null ||
                dataIndex.plantID == '' ||
                dataIndex.plantID == null ||
                dataIndex.uom == '' ||
                dataIndex.uom == null ||
                dataIndex.crfCreatedDate == '' ||
                dataIndex.crfCreatedDate[0] == null) {
                completion = false;
            }
            else {
                if (dataIndex.listSubItems.length == 0) {
                    completion = true;
                }
                else {
                    for (const i of dataIndex.listSubItems) {
                        if (i.description == '' ||
                            i.description == null ||
                            i.quantity == '' ||
                            i.quantity == null ||
                            i.uom == '' ||
                            i.uom == null ||
                            (data.isRental &&
                                !data.budgetByPicProc &&
                                (i.code == '' || i.code == null))) {
                            completion = false;
                            break;
                        }
                        else {
                            completion = true;
                        }
                    }
                }
                if (data.isAllowEditMF &&
                    !data.isDisabled &&
                    !data.onlyCreator &&
                    !data.budgetByPicProc) {
                    if (dataIndex.rentalType == '' ||
                        dataIndex.rentalType == null ||
                        ((dataIndex.mutationQuantity == '' ||
                            dataIndex.mutationQuantity == null) &&
                            dataIndex.rentalType.toLowerCase() == 'mutasi') ||
                        ((dataIndex.mutationFrom == '' || dataIndex.mutationFrom == null) &&
                            dataIndex.rentalType.toLowerCase() == 'mutasi')) {
                        completion = false;
                    }
                }
            }
            if (data.isRental &&
                !data.budgetByPicProc &&
                dataIndex.listSubItems.length == 0) {
                completion = false;
            }
            dataIndex.isSaved = completion;
            if (completion)
                this.isShowMessageRincianInfo = false;
        }
    }
    ['setSubmitDialog'](data) {
        this.submitDialog = data;
    }
    get getIsSubmitError() {
        return this.isSubmitError;
    }
    ['setIsSubmitError'](data) {
        this.isSubmitError.conditions = data.conditions;
        this.isSubmitError.message = data.message;
        this.isSubmitError.isField = data.isField;
    }
    ['setSuccessDialog'](data) {
        this.successDialog = data;
    }
    ['setSubmitInfoDialog'](data) {
        this.submitInfoDialog = data;
    }
    ['setDiscardDialog'](data) {
        this.discardDialog = data;
    }
    ['setImportDialogCrf']() {
        const myModal = new bootstrap.Modal(document.getElementById('modal_import_gr_item'));
        myModal.show();
    }
    ['setImportConditionCrf'](data) {
        this.importCondition = data;
    }
    ['setImportFileCrf']({ files, data, isError }) {
        if (isError)
            this.importFileCrf.isError = isError;
        else {
            this.importFileCrf.store.push(data);
            this.importFileCrf.files = files;
            this.importFileCrf.isError = isError;
        }
    }
    ['deleteImportFileCrf'](fileName) {
        const index = this.importFileCrf.store
            .map((x) => {
            return x.originalFileName;
        })
            .indexOf(fileName);
        this.importFileCrf.store.splice(index, 1);
        this.importFileCrf.files = null;
        this.importFileCrf.isError = false;
    }
    ['setCRFTabFromFPK'](data) {
        this.tabCrf.expenditure = data.expenditure;
        this.tabCrf.community = data.community;
    }
    ['deleteRowRincianInformasi'](data) {
        this.rincianInformasiArray.splice(data, 1);
    }
    ['editRowRincian'](data) {
        this.rincianInformasiArray[data].isSaved = false;
        this.rincianInformasiArray[data].isSaveClicked = false;
        this.rincianInformasiArray[data].isIndexEdit = true;
    }
    ['deleteRowRincianInformasiChild'](data) {
        this.rincianInformasiArray[data.parent].listSubItems.splice(data.child, 1);
    }
    ['duplicateRincianInformasiArray'](array) {
        const subs = [];
        array.listSubItems.forEach((element) => {
            subs.push({
                description: element.description,
                isDescriptionTouched: element.isDescriptionTouched,
                quantity: element.quantity,
                isQuantityTouched: element.isQuantityTouched,
                uom: element.uom,
                isUomTouched: element.isUomTouched,
                code: element.code,
                additionalCode: element.additionalCode,
                remarks: element.remarks
            });
        });
        this.rincianInformasiArray.push({
            uom: array.uom,
            isUomTouched: array.isUomTouched,
            description: array.description,
            isDeskripsiTouched: array.isDeskripsiTouched,
            currency: array.currency,
            isCurrencyTouched: array.isCurrencyTouched,
            exchangeRate: array.exchangeRate,
            estimasiBiaya: array.estimasiBiaya,
            isEstimasiBiayaTouched: array.isEstimasiBiayaTouched,
            isSaved: array.isSaved,
            quantity: array.quantity,
            isQuantityTouched: array.isQuantityTouched,
            plantID: array.plantID,
            plantIDName: array.plantIDName,
            isPlantTouched: array.isPlantTouched,
            crfCreatedDate: array.crfCreatedDate,
            isCrfCreatedDateTouched: array.isCrfCreatedDateTouched,
            periode: array.periode,
            isIndexEdit: array.isIndexEdit,
            isSaveClicked: array.isSaveClicked,
            rentalType: array.rentalType,
            isRentalTouched: array.isRentalTouched,
            mutationQuantity: array.mutationQuantity,
            isMutationQuantityTouched: array.isMutationQuantityTouched,
            newOrderQuantity: array.newOrderQuantity,
            mutationFrom: array.mutationFrom,
            isMutationFromTouched: array.isMutationFromTouched,
            listSubItems: subs
        });
    }
    ['resetState']() {
        this.isShowMessageRincianInfo = false;
        this.afterCallApi = false;
        this.isAllowSubmit = true;
        this.formComment = {
            comment: '',
            isLoading: false
        };
        document.cookie = `expenditureDefault=${null}`;
        this.jobTypeLabel = '';
        this.buttonIsDraftChange = false;
        this.runWorkFlowID = null;
        this.draftClick = '';
        this.isDraftJci = false;
        this.isDraftFpk = false;
        this.fieldSecuritySettings = {
            allowEdit: '',
            allowView: ''
        };
        this.tabTypeFirstLand = true;
        this.workflowFirstLand = true;
        this.workflowDataStore = [];
        this.isSubmitError = {
            conditions: false,
            message: '',
            isField: null
        };
        this.tabConditions = '';
        this.isFirstTouch = true;
        this.submitDialog = false;
        this.successDialog = false;
        this.discardDialog = false;
        this.importDialog = false;
        this.importCondition = 'crf';
        this.tabAdditional = {
            riskAssessment: '',
            AdditionalInformation: '',
            isAdditionalInformationTouched: false,
            remarks: '',
            scopeOfWorkFiles: [],
            isScopeOfWorkTouched: false,
            perizinanKhususFiles: [],
            structureCostFiles: [],
            isStructureCostTouched: false,
            slaFiles: [],
            isSlaTouched: false,
            riskAssessmentFiles: [],
            keteranganTambahanFiles: [],
            isKeteranganTambahanTouched: false,
            ibprFiles: [],
            isSubmitClicked: false,
            isComplete: ''
        };
        this.tabCrf = {
            crfNo: '',
            jobTypeID: null,
            jobTypeDescription: '',
            isJobTypeTouched: false,
            community: null,
            isCommunityTouched: false,
            expenditure: '',
            isExpenditureTouched: false,
            transaksiBulky: null,
            isTransaksiBulkyTouched: false,
            brrfFiles: [],
            isBrrfTouched: false,
            function: '',
            isFunctionTouched: false,
            isSubmitClicked: false,
            isComplete: ''
        };
        this.tabRkk = {
            picProcurementName: '',
            tanggalCrfDibuat: '',
            crfCreatedDate: [],
            isCrfCreatedDateTouched: false,
            contractPeriod: '',
            kebutuhanPekerjaan: '',
            isKebutuhanPekerjaanTouched: false,
            previousContractNo: '',
            isPreviousContractNoTouched: false,
            isExtension: null,
            isExtensionTouched: false,
            extensionPeriod: '',
            isExtensionPeriodTouched: false,
            picProcurementID: '',
            isPicProcurementIDTouched: false,
            isSubmitClicked: false,
            isComplete: ''
        };
        this.tabLocationUser = [];
        this.isTabLocationUserTouched = false;
        this.tabLocationDelivery = [];
        this.isTabLocationDeliveryTouched = false;
        this.locationComplete = '';
        this.isSubmitLocationClicked = false;
        this.lookupPersons = [];
        this.isSubmitClicked = false;
        // Form Data
        this.rincianInformasiArray = [
            {
                uom: '',
                isUomTouched: false,
                description: '',
                isDeskripsiTouched: false,
                currency: '',
                isCurrencyTouched: false,
                exchangeRate: '',
                estimasiBiaya: '',
                isEstimasiBiayaTouched: false,
                isSaved: false,
                quantity: '',
                isQuantityTouched: false,
                plantID: '',
                isPlantTouched: false,
                crfCreatedDate: [],
                isCrfCreatedDateTouched: false,
                periode: '',
                listSubItems: [],
                isSaveClicked: false,
                rentalType: '',
                isRentalTouched: false,
                mutationQuantity: null,
                isMutationQuantityTouched: false,
                newOrderQuantity: null,
                mutationFrom: '',
                isMutationFromTouched: false
            }
        ];
        this.errorDownloadTemplate = {};
        this.errorImportTemplate = {};
        this.isOnImport = false;
        this.isSuccessImported = false;
        this.isGenerateClicked = false;
        this.importFileCrf.files = null;
        this.importFileCrf.store = [];
        this.importFileCrf.isError = false;
        this.importFileCrf.isImported = false;
        this.importFileCrf.isAllowImport = true;
    }
    ['setIsHo6'](data) {
        this.isHo6 = data;
    }
    ['setErrorTabCrf'](data) {
        this.listError.tabCrf.push(data);
    }
    ['setErrorTabRkk'](data) {
        this.listError.tabRkk.push(data);
    }
    ['setErrorTabLokasi'](data) {
        this.listError.tabLokasi.push(data);
    }
    ['setErrorTabRincianInformasi'](data) {
        this.listError.tabRincianInformasi.push(data);
    }
    ['setErrorTabAdditionalInfo'](data) {
        this.listError.tabAdditionalInfo.push(data);
    }
    ['setResetErrorTab']() {
        this.listError = {
            tabCrf: [],
            tabRkk: [],
            tabLokasi: [],
            tabRincianInformasi: [],
            tabAdditionalInfo: []
        };
        this.errorDownloadTemplate = {};
        this.errorImportTemplate = {};
    }
    ['setResetErrorTabSpecific'](tabCode) {
        this.listError[tabCode] = [];
        this.errorDownloadTemplate = {};
        this.errorImportTemplate = {};
    }
    ['setSubmitClick'](data) {
        this.submitClick = data;
    }
    ['getXtokenModule']() {
        return __awaiter(this, void 0, void 0, function* () {
            const instance = new XTokenModule();
            instance.setApiUrl = 'workflow';
            let apiUrl = '';
            let username = '';
            let password = '';
            // Adding flag for changes
            if (window.location.host == 'bspace2-dev.bukitmakmur.com' ||
                window.location.host == 'localhost:8082') {
                apiUrl = instance.getDevNeeds.apiUrl;
                username = instance.getDevNeeds.username;
                password = instance.getDevNeeds.password;
            }
            else if (window.location.host == 'bspace2-uat.bukitmakmur.com') {
                apiUrl = instance.getUatNeeds.apiUrl;
                username = instance.getUatNeeds.username;
                password = instance.getUatNeeds.password;
            }
            else {
                apiUrl = instance.getProdNeeds.apiUrl;
                username = instance.getProdNeeds.username;
                password = instance.getProdNeeds.password;
            }
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const querystring = require('querystring');
            return yield new Promise((resolve, reject) => {
                ApiService.postWorkflow(apiUrl, querystring.stringify({
                    grant_type: 'client_credentials'
                }), username, password)
                    .then((response) => {
                    const data = response.data.access_token;
                    this.context.commit('setXtokenModule', data);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['getDetailJciModule']() {
        return __awaiter(this, void 0, void 0, function* () {
            const getHeaderId = window.location.href.split('/');
            const headerId = getHeaderId.pop();
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/jciheader/inquiry?headerID=` +
                headerId +
                '&ver=v1';
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    const data = response.data.result.content;
                    this.context.commit('setDetailJci', data);
                    const obj = {
                        locationID: data.requestor.location,
                        lookupText: data.requestor.locationName,
                        detailLocationType: 'User'
                    };
                    if (data.requestor.location !== '2000') {
                        this.context.commit('addLocationUser', obj);
                    }
                    this.context.commit('setIsLoading', false);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['getDetailFpkModule']() {
        return __awaiter(this, void 0, void 0, function* () {
            const getHeaderId = window.location.href.split('/');
            const headerId = getHeaderId.pop();
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/fpkheader/inquiry?headerID=` +
                headerId +
                '&ver=v1';
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    const data = response.data.result.content;
                    this.context.commit('setDetailFpk', data);
                    const obj = {
                        locationID: data.requestor.location,
                        lookupText: data.requestor.locationName,
                        detailLocationType: 'User'
                    };
                    if (data.requestor.location !== '2000') {
                        this.context.commit('addLocationUser', obj);
                    }
                    this.context.commit('setIsLoading', false);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['getDetailUserModule']() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/master/user?ver=v1`;
            return yield new Promise((resolve, reject) => {
                ApiService.getData(apiUrl)
                    .then((response) => {
                    const data = response.data.result.content;
                    this.context.commit('setDetailUser', data);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['getLookUpFunctionModule']() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/lookup?ver=v1`;
            const params = {
                lookupKey: 'function'
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, params)
                    .then((response) => {
                    const data = response.data.result.content;
                    this.context.commit('setLookUpFunction', data);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['getLookUpPerson'](search) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/lookup?ver=v1`;
            const params = {
                lookupKey: 'PERSON_CHATS',
                search: search
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, params)
                    .then((response) => {
                    const data = response.data.result.content;
                    const tesArray = [];
                    // eslint-disable-next-line arrow-parens, arrow-body-style
                    data.forEach((element) => tesArray.push({
                        value: element.lookupText,
                        lookupVal: element.lookupVal,
                        initial: element.initial,
                        fontColor: element.fontColor,
                        backgroundColor: element.backgroundColor
                    }));
                    this.context.commit('setLookupPerson', data);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['setConversation'](data) {
        this.conversation = data;
    }
    get getConversation() {
        return this.conversation;
    }
    ['getLookUpPersonWithSearch'](parameter) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/lookup?ver=v1`;
            const params = {
                lookupKey: 'PERSON_CHATS',
                search: parameter,
                Length: 10
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, params)
                    .then((response) => {
                    const data = response.data.result.content;
                    this.context.commit('setMention', data[0].lookupVal);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['getLookUp'](parameter) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/lookup?ver=v1`;
            const params = {
                lookupKey: parameter
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, params)
                    .then((response) => {
                    const data = response.data.result.content;
                    if (parameter == 'job_need') {
                        this.context.commit('setLookUpKebutuhanPekerjaan', data);
                    }
                    else if (parameter == 'pic_procurement') {
                        this.context.commit('setLookUpPicProcurement', data);
                    }
                    else if (parameter == 'site') {
                        this.context.commit('setLookUpLokasi', data);
                    }
                    else if (parameter == 'SITE_DELIVERY_LOCATION') {
                        this.context.commit('setLookUpLokasiPengiriman', data);
                    }
                    else if (parameter == 'plant') {
                        this.context.commit('setLookUpPlant', data);
                    }
                    else if (parameter == 'uom') {
                        this.context.commit('setLookUpUom', data);
                    }
                    else if (parameter == 'UOM_KONTRAK_PAYUNG') {
                        this.context.commit('setLookUpUomPayung', data);
                    }
                    else if (parameter == 'occupational_risk_assessment') {
                        this.context.commit('setLookUpRiskAssessment', data);
                    }
                    else if (parameter == 'PERSON_CHATS') {
                        this.context.commit('setLookupPerson', data);
                    }
                    else if (parameter == 'vendor') {
                        this.context.commit('setLookUpVendor', data);
                    }
                    else if (parameter == 'PIC_PROCUREMENT') {
                        this.context.commit('setLookUpPicProc', data);
                    }
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['getLookUpJenisPekerjaanModule']() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/masterjobtype/getbytype?ver=v1`;
            return yield new Promise((resolve, reject) => {
                ApiService.getData(apiUrl)
                    .then((response) => {
                    const data = response.data.result.content;
                    this.context.commit('setLookUpJenisPekerjaan', data);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['uploadFiles'](file) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/upload?module=JCI&ver=v1`;
            // eslint-disable-next-line prefer-const, no-var
            let dataForm = new FormData();
            dataForm.append('file', file);
            return yield new Promise((resolve, reject) => {
                ApiService.postImages(apiUrl, dataForm)
                    .then((response) => {
                    const data = response.data.result.content;
                    const fileName = `${data.originalFileName}.${data.fileType}`;
                    const getFile = this.tabCrf.brrfFiles.findIndex((s) => {
                        return s.originalFileName == fileName;
                    });
                    if (getFile >= 0) {
                        this.tabCrf.brrfFiles[getFile] = Object.assign(Object.assign({}, data), { isSuccessDownload: false, isFailedDownload: false, isDownloading: false });
                    }
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['uploadFilesTabAdditionalInfo'](params) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/upload?module=JCI&ver=v1`;
            // eslint-disable-next-line prefer-const, no-var
            let dataForm = new FormData();
            dataForm.append('file', params.files);
            return yield new Promise((resolve, reject) => {
                ApiService.postImages(apiUrl, dataForm)
                    .then((response) => {
                    const data = response.data.result.content;
                    const fileName = `${data.originalFileName}.${data.fileType}`;
                    let getFile = 0;
                    const newData = Object.assign(Object.assign({}, data), { isSuccessDownload: false, isFailedDownload: false, isDownloading: false });
                    switch (params.conditions) {
                        case 'scopeOfWork':
                            getFile = this.tabAdditional.scopeOfWorkFiles.findIndex((s) => {
                                return s.originalFileName == fileName;
                            });
                            if (getFile >= 0) {
                                this.tabAdditional.scopeOfWorkFiles[getFile] = newData;
                            }
                            break;
                        case 'perizinanKhusus':
                            getFile = this.tabAdditional.perizinanKhususFiles.findIndex((s) => {
                                return s.originalFileName == fileName;
                            });
                            if (getFile >= 0) {
                                this.tabAdditional.perizinanKhususFiles[getFile] = newData;
                            }
                            break;
                        case 'structureCost':
                            getFile = this.tabAdditional.structureCostFiles.findIndex((s) => {
                                return s.originalFileName == fileName;
                            });
                            if (getFile >= 0) {
                                this.tabAdditional.structureCostFiles[getFile] = newData;
                            }
                            break;
                        case 'sla':
                            getFile = this.tabAdditional.slaFiles.findIndex((s) => {
                                return s.originalFileName == fileName;
                            });
                            if (getFile >= 0) {
                                this.tabAdditional.slaFiles[getFile] = newData;
                            }
                            break;
                        case 'riskAssessment':
                            getFile = this.tabAdditional.riskAssessmentFiles.findIndex((s) => {
                                return s.originalFileName == fileName;
                            });
                            if (getFile >= 0) {
                                this.tabAdditional.riskAssessmentFiles[getFile] = newData;
                            }
                            break;
                        case 'keteranganTambahan':
                            getFile = this.tabAdditional.keteranganTambahanFiles.findIndex((s) => {
                                return s.originalFileName == fileName;
                            });
                            if (getFile >= 0) {
                                this.tabAdditional.keteranganTambahanFiles[getFile] = newData;
                            }
                            break;
                        case 'ibpr':
                            getFile = this.tabAdditional.ibprFiles.findIndex((s) => {
                                return s.originalFileName == fileName;
                            });
                            if (getFile >= 0) {
                                this.tabAdditional.ibprFiles[getFile] = newData;
                            }
                            break;
                    }
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['deleteFile'](fileUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/upload?fileUrl=` +
                fileUrl +
                '&module=JCI&ver=v1';
            return yield new Promise((resolve, reject) => {
                ApiService.delete(apiUrl)
                    .then(() => {
                    const index = this.tabCrf.brrfFiles
                        .map((x) => {
                        return x.fileUrl;
                    })
                        .indexOf(fileUrl);
                    this.tabCrf.brrfFiles.splice(index, 1);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['deleteFilesAdditionalInfo'](params) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/upload?fileUrl=` +
                params.file +
                '&module=JCI&ver=v1';
            return yield new Promise((resolve, reject) => {
                ApiService.delete(apiUrl)
                    .then(() => {
                    if (params.conditions == 'scopeOfWork') {
                        const index = this.tabAdditional.scopeOfWorkFiles
                            .map((x) => {
                            return x.fileUrl;
                        })
                            .indexOf(params.file);
                        this.tabAdditional.scopeOfWorkFiles.splice(index, 1);
                    }
                    else if (params.conditions == 'perizinanKhusus') {
                        const index = this.tabAdditional.perizinanKhususFiles
                            .map((x) => {
                            return x.fileUrl;
                        })
                            .indexOf(params.file);
                        this.tabAdditional.perizinanKhususFiles.splice(index, 1);
                    }
                    else if (params.conditions == 'structureCost') {
                        const index = this.tabAdditional.structureCostFiles
                            .map((x) => {
                            return x.fileUrl;
                        })
                            .indexOf(params.file);
                        this.tabAdditional.structureCostFiles.splice(index, 1);
                    }
                    else if (params.conditions == 'sla') {
                        const index = this.tabAdditional.slaFiles
                            .map((x) => {
                            return x.fileUrl;
                        })
                            .indexOf(params.file);
                        this.tabAdditional.slaFiles.splice(index, 1);
                    }
                    else if (params.conditions == 'riskAssessment') {
                        const index = this.tabAdditional.riskAssessmentFiles
                            .map((x) => {
                            return x.fileUrl;
                        })
                            .indexOf(params.file);
                        this.tabAdditional.riskAssessmentFiles.splice(index, 1);
                    }
                    else if (params.conditions == 'keteranganTambahan') {
                        const index = this.tabAdditional.keteranganTambahanFiles
                            .map((x) => {
                            return x.fileUrl;
                        })
                            .indexOf(params.file);
                        this.tabAdditional.keteranganTambahanFiles.splice(index, 1);
                    }
                    else if (params.conditions == 'ibpr') {
                        const index = this.tabAdditional.ibprFiles
                            .map((x) => {
                            return x.fileUrl;
                        })
                            .indexOf(params.file);
                        this.tabAdditional.ibprFiles.splice(index, 1);
                    }
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['getExchangeRateModule'](params) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/master/currentrateidr?ver=v1&fromCurrency=` +
                params;
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    const data = response.data.result.content.exchangeRate;
                    if (params == 'USD') {
                        this.context.commit('setUSDRate', data);
                    }
                    else if (params == 'IDR') {
                        this.context.commit('setIDRRate', data);
                    }
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['submitCrf'](parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit('setSubmitDialog', false);
            this.context.commit('setDiscardDialog', false);
            this.context.commit('setSubmitClick', true);
            this.context.commit('setSubmissionLoading', true);
            // if success submit location
            const locations = [];
            // Store references to state properties to avoid direct access inside the loop
            const locationUserArray = this.tabLocationUser;
            const locationDeliveryArray = this.tabLocationDelivery;
            for (const g of locationUserArray) {
                locations.push({
                    detailLocationID: g.detailLocationID,
                    detailLocationType: g.detailLocationType,
                    locationID: g.locationID,
                    locationName: g.lookupText
                });
            }
            for (const g of locationDeliveryArray) {
                locations.push({
                    detailLocationID: g.detailLocationID,
                    detailLocationType: g.detailLocationType,
                    locationID: g.locationID,
                    locationName: g.lookupText
                });
            }
            // if success rincian informasi
            const items = [];
            // Store references to state properties to avoid direct access inside the loop
            const rincianArray = this.rincianInformasiArray;
            const jobTypeDesc = this.tabCrf.jobTypeDescription;
            for (const dataItem of rincianArray) {
                const crfCreatedDateArray = Array.isArray(dataItem.crfCreatedDate)
                    ? dataItem.crfCreatedDate
                    : [];
                const [startDateRincian, endDateRincian] = crfCreatedDateArray.map((date) => (date ? moment(date).format('YYYY-MM-DD') : null));
                const biaya = dataItem.estimasiBiaya
                    ? dataItem.estimasiBiaya.split(',').join('')
                    : '';
                const quantity = dataItem.quantity
                    ? dataItem.quantity.split(',').join('')
                    : '';
                const mutationQuantity = dataItem.mutationQuantity
                    ? dataItem.mutationQuantity.split(',').join('')
                    : '';
                const newOrderQtyString = dataItem.newOrderQuantity != null &&
                    dataItem.newOrderQuantity !== undefined
                    ? dataItem.newOrderQuantity.toString()
                    : '';
                const newOrderQuantity = jobTypeDesc.toLowerCase() === 'rental' && newOrderQtyString
                    ? newOrderQtyString.split(',').join('')
                    : '';
                const listSubItemsArray = Array.isArray(dataItem.listSubItems)
                    ? dataItem.listSubItems
                    : [];
                const subArray = listSubItemsArray.map((dataSub) => {
                    dataSub.isDescriptionTouched = true;
                    dataSub.isQuantityTouched = true;
                    dataSub.isUomTouched = true;
                    const subQuantity = dataSub.quantity
                        ? dataSub.quantity.split(',').join('')
                        : '';
                    return {
                        detailSubItemID: dataSub.detailSubItemID,
                        description: dataSub.description,
                        quantity: Number(subQuantity),
                        uom: dataSub.uom,
                        code: dataSub.code,
                        additionalCode: dataSub.additionalCode,
                        remarks: dataSub.remarks
                    };
                });
                items.push({
                    detailItemID: dataItem.detailItemID,
                    uom: dataItem.uom,
                    description: dataItem.description,
                    currency: dataItem.currency,
                    costEstimation: Number(biaya),
                    quantity: Number(quantity),
                    startDate: startDateRincian,
                    endDate: endDateRincian,
                    PlantID: dataItem.plantID,
                    rentalType: dataItem.rentalType,
                    mutationQuantity: Number(mutationQuantity),
                    mutationFrom: dataItem.mutationFrom || '',
                    newOrderQuantity: Number(newOrderQuantity),
                    listSubItems: subArray
                });
            }
            // If success submit attachment
            const attachments = [];
            const nameUploadFile = [
                'brrf',
                'scopeOfWork',
                'perizinanKhusus',
                'structureCost',
                'sla',
                'riskAssessment',
                'keteranganTambahan',
                'ibpr'
            ];
            const sourceList = {
                crf: 'tabCrf',
                rkk: 'tabRkk',
                additional: 'tabAdditional'
            };
            const listFiles = {
                brrf: 'brrfFiles',
                scopeOfWork: 'scopeOfWorkFiles',
                perizinanKhusus: 'perizinanKhususFiles',
                structureCost: 'structureCostFiles',
                sla: 'slaFiles',
                riskAssessment: 'riskAssessmentFiles',
                keteranganTambahan: 'keteranganTambahanFiles',
                ibpr: 'ibprFiles'
            };
            const attachmentType = {
                brrf: 'BRRF',
                scopeOfWork: 'SCOPEOFWORK',
                perizinanKhusus: 'PERIZINANKHUSUS',
                structureCost: 'STRUCTURECOST',
                sla: 'SLA',
                riskAssessment: 'PENILAIANRISIKOPEKERJAAN',
                keteranganTambahan: 'KETERANGANTAMBAHAN',
                ibpr: 'IBPR'
            };
            for (const gn of nameUploadFile) {
                const getNameList = gn == 'brrf' ? sourceList.crf : sourceList.additional;
                const getList = this[getNameList][listFiles[gn]];
                for (const g of getList) {
                    attachments.push({
                        attachmentID: g.attachmentID,
                        attachmentType: attachmentType[gn],
                        originalFileName: g.originalFileName,
                        formattedFileName: g.formattedFileName,
                        fileType: g.fileType,
                        fileUrl: g.fileUrl
                    });
                }
            }
            let startDate;
            let endDate;
            if (this.tabRkk.crfCreatedDate[0] == undefined ||
                this.tabRkk.crfCreatedDate[0] == '') {
                startDate = null;
            }
            else {
                startDate = moment(this.tabRkk.crfCreatedDate[0]).format('YYYY-MM-DD');
            }
            if (this.tabRkk.crfCreatedDate[1] == undefined ||
                this.tabRkk.crfCreatedDate[1] == '') {
                endDate = null;
            }
            else {
                endDate = moment(this.tabRkk.crfCreatedDate[1]).format('YYYY-MM-DD');
            }
            const extentionPeriod = this.tabRkk.extensionPeriod
                ? this.tabRkk.extensionPeriod.split(',')
                : [];
            const extentionPeriodMerged = extentionPeriod.join('');
            const getExpenditureDefault = document.cookie.match(new RegExp('(^| )expenditureDefault=([^;]+)')) || [];
            let purchaseTypeExpenditureValue;
            if (getExpenditureDefault[2] == 'null') {
                purchaseTypeExpenditureValue = null;
            }
            else {
                purchaseTypeExpenditureValue = getExpenditureDefault[2];
            }
            const params = {
                TransactionNoFPKJCI: parameters.transactionNo,
                JobTypeID: Number(this.tabCrf.jobTypeID),
                TransactionType: parameters.type,
                Community: this.tabCrf.community,
                Expenditure: this.tabCrf.expenditure,
                TransaksiBulky: this.tabCrf.transaksiBulky,
                WorkStartDate: startDate,
                WorkEndDate: endDate,
                JobNeed: this.tabRkk.kebutuhanPekerjaan,
                PreviousContractNo: this.tabRkk.previousContractNo,
                IsExtension: this.tabRkk.isExtension,
                ExtensionPeriod: Number(extentionPeriodMerged),
                PicProcurementID: this.tabRkk.picProcurementID,
                Runworkflowid: this.runWorkFlowID,
                FunctionNameApproval: this.tabCrf.function,
                AdditionalInformation: this.tabAdditional.AdditionalInformation,
                OccupationalRiskAssessment: this.tabAdditional.riskAssessment,
                remarks: this.tabAdditional.remarks,
                ListAttachments: attachments,
                ListLocations: locations,
                ListItems: items,
                purchaseTypeExpenditure: purchaseTypeExpenditureValue
            };
            const listApi = {
                submit: `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/submit?ver=v1`,
                draft: `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/draft?ver=v1`,
                submitdraft: `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/submitdraft?ver=v1`,
                revise: `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/revise?ver=v1`
            };
            const methodService = {
                withToken: {
                    post: 'post',
                    put: 'put'
                }
            };
            const withPost = parameters.conditions == 'submit' || parameters.conditions == 'draft';
            const apiUrl = listApi[parameters.conditions];
            return yield new Promise((resolve, reject) => {
                ApiService[withPost ? methodService.withToken.post : methodService.withToken.put](apiUrl, params)
                    .then((response) => {
                    this.context.commit('setIsAllowSubmitCrf', true);
                    const data = response.data.result.content;
                    if (response.data.result.isError) {
                        const dataError = {
                            conditions: response.data.result.isError,
                            message: response.data.result.message,
                            isField: data == null ? false : true
                        };
                        this.context.commit('setIsSubmitError', dataError);
                        if (data != null && response.data.result.isError) {
                            this.context.commit('setResetErrorTab');
                            const listMutation = {
                                tabCrf: 'setErrorTabCrf',
                                tabRkk: 'setErrorTabRkk',
                                tabLokasi: 'setErrorTabLokasi',
                                tabRincian: 'setErrorTabRincianInformasi',
                                tabAdditionalInfo: 'setErrorTabAdditionalInfo'
                            };
                            data.errorSets.forEach((g) => {
                                this.context.commit(listMutation[g.field.tabCode], g);
                            });
                        }
                    }
                    else {
                        this.context.commit('setResetErrorTab');
                        if (response.data.result.content.inProgress) {
                            this.context.commit('setSubmitInfoMessage', response.data.result.message);
                            this.context.commit('setSubmitInfoDialog', true);
                        }
                        else
                            this.context.commit('setSuccessDialog', true);
                    }
                    this.context.commit('setSubmissionLoading', false);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['setJobTypeLabel'](data) {
        this.jobTypeLabel = data;
    }
    get getJobTypeLabel() {
        return this.jobTypeLabel;
    }
    ['callApiDraft'](content) {
        return __awaiter(this, void 0, void 0, function* () {
            let apiUrl = '';
            if (content.conditions == 'draft') {
                apiUrl =
                    `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/detail/draft?headerID=` +
                        content.headerID +
                        '&ver=v1';
            }
            else if (content.conditions == 'revise') {
                apiUrl =
                    `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/detail?headerID=` +
                        content.headerID +
                        '&ver=v1';
            }
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    if (response.data.result.isError) {
                        this.context.commit('setShowErrorDialog', true);
                        const dataError = {
                            conditions: false,
                            message: response.data.result.message,
                            isField: false
                        };
                        this.context.commit('setIsSubmitError', dataError);
                        this.context.commit('setIsLoading', false);
                        return;
                    }
                    const data = response.data.result.content;
                    document.cookie = `expenditureDefault=${data.purchaseTypeExpenditure}`;
                    if (content.conditions == 'revise' || content.conditions == 'draft') {
                        this.fieldSecuritySettings.allowEdit =
                            data.fieldSecuritySetting.allowEdit;
                        this.fieldSecuritySettings.allowView =
                            data.fieldSecuritySetting.allowView;
                        this.requestorSettings.requestorLevelID = data.requestorLevelID;
                        this.requestorSettings.requestorLocationID =
                            data.requestorLocationID;
                        this.picProcurement.picprcPeriode = data.picprcPeriode;
                        if (data.picprcSpendingValue == 0)
                            this.picProcurement.picprcSpendingValue = '-';
                        else
                            this.picProcurement.picprcSpendingValue = Func.format2(data.picprcSpendingValue.toString());
                        this.picProcurement.picprcSpendingValueCurrency =
                            data.picprcSpendingValueCurrency;
                        this.picProcurement.picprcVendorName = data.picprcVendorName;
                        this.summaryBudget.value = data.summaryBudget;
                    }
                    if (content.conditions == 'revise') {
                        this.context.commit('setJobTypeLabel', data.jobTypeDescription);
                    }
                    this.context.commit('setIsDraft', true);
                    if (data.isChangeDraft) {
                        this.context.commit('setDraftChange', true);
                        this.context.commit('setButtonIsDraftChange', true);
                    }
                    if (data.jci != null) {
                        this.context.commit('setIsDraftJci', true);
                        this.context.commit('setDetailJci', data.jci);
                    }
                    else if (data.fpk != null) {
                        this.context.commit('setIsDraftFpk', true);
                        this.context.commit('setDetailFpk', data.fpk);
                    }
                    this.context.commit('setConversation', data.conversation);
                    // Tab CRF
                    this.tabCrf.crfNo = data.crfNo;
                    this.tabCrf.expenditure = data.expenditure;
                    this.tabCrf.jobTypeID = data.jobTypeID || null;
                    this.tabCrf.jobTypeDescription = data.jobTypeDescription;
                    this.tabCrf.transaksiBulky = data.transaksiBulky;
                    this.tabCrf.community = data.community;
                    this.tabCrf.function = data.functionNameApproval;
                    this.context.commit('setHistoriesRevise', data.histories);
                    // TabRkk
                    this.tabRkk.tanggalCrfDibuat = moment(data.createdDate).format('DD MMM YYYY');
                    if (data.workStartDate != null && data.workEndDate != null) {
                        this.tabRkk.crfCreatedDate[0] = moment(data.workStartDate).format('DD MMM YYYY');
                        this.tabRkk.crfCreatedDate[1] = moment(data.workEndDate).format('DD MMM YYYY');
                    }
                    this.tabRkk.kebutuhanPekerjaan = data.jobNeed;
                    this.tabRkk.extensionPeriod = data.extensionPeriod
                        ? Func.currencyFormat(data.extensionPeriod)
                        : null;
                    this.tabRkk.picProcurementID = data.picProcurementID;
                    this.tabRkk.picProcurementName = data.picProcurementName;
                    this.tabRkk.isExtension = data.isExtension;
                    this.tabRkk.previousContractNo = data.previousContractNo;
                    this.tabRkk.contractPeriod = data.contractPeriod
                        ? Func.currencyFormat(data.contractPeriod, true)
                        : null;
                    if (data.jobNeed == 'BARU') {
                        this.tabRkk.kebutuhanPekerjaan = 'Baru';
                    }
                    else if (data.jobNeed == 'ADDENDUM') {
                        this.tabRkk.kebutuhanPekerjaan = 'Addendum';
                    }
                    // Locations
                    for (const g of data.listLocations) {
                        if (g.detailLocationType == 'User') {
                            this.tabLocationUser.push({
                                detailLocationID: g.detailLocationID,
                                locationID: g.locationID,
                                lookupText: g.locationName,
                                detailLocationType: g.detailLocationType
                            });
                        }
                        else {
                            this.tabLocationDelivery.push({
                                detailLocationID: g.detailLocationID,
                                locationID: g.locationID,
                                lookupText: g.locationName,
                                detailLocationType: g.detailLocationType
                            });
                        }
                    }
                    // RincianInformasi
                    if (data.listItems.length != 0) {
                        for (let i = 0; i < data.listItems.length; i++) {
                            if (i > 0) {
                                if (data.listItems[i].listSubitems.length != 0) {
                                    const arrayListSub = [];
                                    data.listItems[i].listSubitems.forEach((element) => {
                                        arrayListSub.push({
                                            detailSubItemID: element.detailSubItemID,
                                            description: element.description,
                                            isDescriptionTouched: false,
                                            quantity: element.quantity
                                                ? Func.currencyFormat(element.quantity)
                                                : null,
                                            isQuantityTouched: false,
                                            uom: element.uom,
                                            isUomTouched: false,
                                            code: element.code,
                                            additionalCode: element.additionalCode,
                                            remarks: element.remarks
                                        });
                                    });
                                    const rincianInfoDatee = [];
                                    if (data.listItems[i].startDate != null &&
                                        data.listItems[i].endDate != null) {
                                        rincianInfoDatee[0] = moment(data.listItems[i].startDate).format('DD MMM YYYY');
                                        rincianInfoDatee[1] = moment(data.listItems[i].endDate).format('DD MMM YYYY');
                                    }
                                    let estimasiPreventZero = null;
                                    if (data.listItems[i].costEstimation != 0) {
                                        estimasiPreventZero =
                                            Func.format2(data.listItems[i].costEstimation.toString()) == '0.00'
                                                ? ''
                                                : Func.format2(data.listItems[i].costEstimation.toString());
                                    }
                                    this.rincianInformasiArray.push({
                                        detailItemID: data.listItems[i].detailItemID,
                                        uom: data.listItems[i].uom,
                                        description: data.listItems[i].description,
                                        isDeskripsiTouched: false,
                                        currency: data.listItems[i].currency,
                                        isCurrencyTouched: false,
                                        exchangeRate: '',
                                        estimasiBiaya: estimasiPreventZero,
                                        isEstimasiBiayaTouched: false,
                                        isSaved: false,
                                        quantity: data.listItems[i].quantity
                                            ? Func.currencyFormat(data.listItems[i].quantity)
                                            : null,
                                        isQuantityTouched: false,
                                        plantID: data.listItems[i].plantID,
                                        plantIDName: data.listItems[i].plantIDName,
                                        isPlantTouched: false,
                                        crfCreatedDate: rincianInfoDatee,
                                        isCrfCreatedDateTouched: false,
                                        periode: data.listItems[i].period
                                            ? Func.currencyFormat(data.listItems[i].period, true)
                                            : null,
                                        listSubItems: arrayListSub,
                                        isSaveClicked: false,
                                        rentalType: data.listItems[i].rentalType,
                                        isRentalTouched: false,
                                        mutationQuantity: data.listItems[i].mutationQuantity == 0
                                            ? null
                                            : Func.currencyFormat(data.listItems[i].mutationQuantity),
                                        isMutationQuantityTouched: false,
                                        newOrderQuantity: Func.currencyFormat(data.listItems[i].newOrderQuantity),
                                        mutationFrom: data.listItems[i].mutationFrom,
                                        isMutationFromTouched: false
                                    });
                                }
                                else {
                                    const rincianInfoDate = [];
                                    if (data.listItems[i].startDate != null &&
                                        data.listItems[i].endDate != null) {
                                        rincianInfoDate[0] = moment(data.listItems[i].startDate).format('DD MMM YYYY');
                                        rincianInfoDate[1] = moment(data.listItems[i].endDate).format('DD MMM YYYY');
                                    }
                                    let estimasiPreventZero = null;
                                    if (data.listItems[i].costEstimation != 0) {
                                        estimasiPreventZero =
                                            Func.format2(data.listItems[i].costEstimation.toString()) == '0.00'
                                                ? ''
                                                : Func.format2(data.listItems[i].costEstimation.toString());
                                    }
                                    this.rincianInformasiArray.push({
                                        detailItemID: data.listItems[i].detailItemID,
                                        uom: data.listItems[i].uom,
                                        description: data.listItems[i].description,
                                        isDeskripsiTouched: false,
                                        currency: data.listItems[i].currency,
                                        isCurrencyTouched: false,
                                        exchangeRate: '',
                                        estimasiBiaya: estimasiPreventZero,
                                        isEstimasiBiayaTouched: false,
                                        isSaved: false,
                                        quantity: data.listItems[i].quantity
                                            ? Func.currencyFormat(data.listItems[i].quantity)
                                            : null,
                                        isQuantityTouched: false,
                                        plantID: data.listItems[i].plantID,
                                        plantIDName: data.listItems[i].plantIDName,
                                        isPlantTouched: false,
                                        crfCreatedDate: rincianInfoDate,
                                        isCrfCreatedDateTouched: false,
                                        periode: data.listItems[i].period
                                            ? Func.currencyFormat(data.listItems[i].period, true)
                                            : null,
                                        listSubItems: [],
                                        isSaveClicked: false,
                                        rentalType: data.listItems[i].rentalType,
                                        isRentalTouched: false,
                                        mutationQuantity: data.listItems[i].mutationQuantity == 0
                                            ? null
                                            : Func.currencyFormat(data.listItems[i].mutationQuantity),
                                        isMutationQuantityTouched: false,
                                        newOrderQuantity: Func.currencyFormat(data.listItems[i].newOrderQuantity),
                                        mutationFrom: data.listItems[i].mutationFrom,
                                        isMutationFromTouched: false
                                    });
                                }
                            }
                            else if (i == 0) {
                                let estimasiPreventZero = null;
                                if (data.listItems[i].costEstimation != 0) {
                                    estimasiPreventZero =
                                        Func.format2(data.listItems[i].costEstimation.toString()) ==
                                            '0.00'
                                            ? ''
                                            : Func.format2(data.listItems[i].costEstimation.toString());
                                }
                                if (data.listItems[i].listSubitems.length != 0) {
                                    this.rincianInformasiArray[0].detailItemID =
                                        data.listItems[i].detailItemID;
                                    this.rincianInformasiArray[0].uom = data.listItems[i].uom;
                                    this.rincianInformasiArray[0].description =
                                        data.listItems[i].description;
                                    this.rincianInformasiArray[0].currency =
                                        data.listItems[i].currency;
                                    this.rincianInformasiArray[0].estimasiBiaya =
                                        estimasiPreventZero;
                                    this.rincianInformasiArray[0].quantity = data.listItems[i]
                                        .quantity
                                        ? Func.currencyFormat(data.listItems[i].quantity)
                                        : null;
                                    this.rincianInformasiArray[0].plantID =
                                        data.listItems[i].plantID;
                                    this.rincianInformasiArray[0].plantIDName =
                                        data.listItems[i].plantIDName;
                                    if (data.listItems[i].startDate != null &&
                                        data.listItems[i].endDate != null) {
                                        this.rincianInformasiArray[0].crfCreatedDate[0] = moment(data.listItems[i].startDate).format('DD MMM YYYY');
                                        this.rincianInformasiArray[0].crfCreatedDate[1] = moment(data.listItems[i].endDate).format('DD MMM YYYY');
                                    }
                                    this.rincianInformasiArray[0].periode = data.listItems[i]
                                        .period
                                        ? Func.currencyFormat(data.listItems[i].period, true)
                                        : null;
                                    this.rincianInformasiArray[0].rentalType =
                                        data.listItems[i].rentalType;
                                    this.rincianInformasiArray[0].mutationQuantity =
                                        data.listItems[i].mutationQuantity == 0
                                            ? null
                                            : Func.currencyFormat(data.listItems[i].mutationQuantity);
                                    this.rincianInformasiArray[0].newOrderQuantity =
                                        Func.currencyFormat(data.listItems[i].newOrderQuantity);
                                    this.rincianInformasiArray[0].mutationFrom =
                                        data.listItems[i].mutationFrom;
                                    data.listItems[i].listSubitems.forEach((element) => {
                                        this.rincianInformasiArray[0].listSubItems.push({
                                            detailSubItemID: element.detailSubItemID,
                                            description: element.description,
                                            isDescriptionTouched: false,
                                            quantity: element.quantity
                                                ? Func.currencyFormat(element.quantity)
                                                : null,
                                            isQuantityTouched: false,
                                            uom: element.uom,
                                            isUomTouched: false,
                                            code: element.code,
                                            additionalCode: element.additionalCode,
                                            remarks: element.remarks
                                        });
                                    });
                                }
                                else {
                                    let estimasiPreventZero = null;
                                    if (data.listItems[i].costEstimation != 0) {
                                        estimasiPreventZero =
                                            Func.format2(data.listItems[i].costEstimation.toString()) == '0.00'
                                                ? ''
                                                : Func.format2(data.listItems[i].costEstimation.toString());
                                    }
                                    this.rincianInformasiArray[0].detailItemID =
                                        data.listItems[i].detailItemID;
                                    this.rincianInformasiArray[0].uom = data.listItems[i].uom;
                                    this.rincianInformasiArray[0].description =
                                        data.listItems[i].description;
                                    this.rincianInformasiArray[0].currency =
                                        data.listItems[i].currency;
                                    this.rincianInformasiArray[0].estimasiBiaya =
                                        estimasiPreventZero;
                                    this.rincianInformasiArray[0].quantity = data.listItems[i]
                                        .quantity
                                        ? Func.currencyFormat(data.listItems[i].quantity)
                                        : null;
                                    this.rincianInformasiArray[0].plantID =
                                        data.listItems[i].plantID;
                                    this.rincianInformasiArray[0].plantIDName =
                                        data.listItems[i].plantIDName;
                                    if (data.listItems[i].startDate != null &&
                                        data.listItems[i].endDate != null) {
                                        this.rincianInformasiArray[0].crfCreatedDate[0] = moment(data.listItems[i].startDate).format('DD MMM YYYY');
                                        this.rincianInformasiArray[0].crfCreatedDate[1] = moment(data.listItems[i].endDate).format('DD MMM YYYY');
                                    }
                                    this.rincianInformasiArray[0].periode = data.listItems[i]
                                        .period
                                        ? Func.currencyFormat(data.listItems[i].period, true)
                                        : null;
                                    this.rincianInformasiArray[0].rentalType =
                                        data.listItems[i].rentalType;
                                    this.rincianInformasiArray[0].mutationQuantity =
                                        data.listItems[i].mutationQuantity == 0
                                            ? null
                                            : Func.currencyFormat(data.listItems[i].mutationQuantity);
                                    this.rincianInformasiArray[0].newOrderQuantity =
                                        Func.currencyFormat(data.listItems[i].newOrderQuantity);
                                    this.rincianInformasiArray[0].mutationFrom =
                                        data.listItems[i].mutationFrom;
                                }
                            }
                        }
                    }
                    // Tab Additional
                    this.tabAdditional.riskAssessment = data.occupationalRiskAssessment;
                    this.tabAdditional.AdditionalInformation = data.additionalInformation;
                    if (content.conditions == 'draft') {
                        this.tabAdditional.remarks = data.remarks;
                    }
                    // Attachments
                    const sourceList = {
                        crf: 'tabCrf',
                        rkk: 'tabRkk',
                        additional: 'tabAdditional'
                    };
                    const listFiles = {
                        BRRF: 'brrfFiles',
                        SCOPEOFWORK: 'scopeOfWorkFiles',
                        PERIZINANKHUSUS: 'perizinanKhususFiles',
                        STRUCTURECOST: 'structureCostFiles',
                        SLA: 'slaFiles',
                        PENILAIANRISIKOPEKERJAAN: 'riskAssessmentFiles',
                        KETERANGANTAMBAHAN: 'keteranganTambahanFiles',
                        IBPR: 'ibprFiles',
                        SUMMARYBUDGET: 'setPicBudgetFile'
                    };
                    for (const g of data.listAttachments) {
                        const getType = g.attachmentType;
                        const getNameList = getType == 'BRRF' ? sourceList.crf : sourceList.additional;
                        if (listFiles[getType] != undefined) {
                            getType != 'SUMMARYBUDGET'
                                ? this[getNameList][listFiles[getType]].push(g)
                                : this.context.commit(listFiles[getType], g);
                        }
                    }
                    this.context.commit('setRunWorkFlowID', data.runWorkflowID);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['downloadPdfCrf'](parameter) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/viewpdf?headerID=` +
                parameter +
                '&ver=v1';
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    window.open(response.data.result.content, '_self', 'download');
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['sendChat'](parameter) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/comment?ver=v1`;
            const params = {
                headerID: parameter.headerID,
                comment: {
                    // if first comment parentID = 0
                    parentCommentID: parameter.commentID,
                    message: parameter.message,
                    mentions: parameter.mentions
                }
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, params)
                    .then(() => {
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['drafChangeClose']() {
        return __awaiter(this, void 0, void 0, function* () {
            const getHeaderId = window.location.href.split('/');
            const headId = getHeaderId.pop();
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/updatedraftclosedate?ver=v1`;
            const params = {
                headerId: headId
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, params)
                    .then(() => {
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    get getDraftChange() {
        return this.isDraftChange;
    }
    ['setDraftChange'](data) {
        this.isDraftChange = data;
    }
    ['callApiConversation'](headerID) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf//api/crf/comment/` +
                headerID +
                '?ver=v1';
            return yield new Promise((resolve, reject) => {
                ApiService.getData(apiUrl)
                    .then((response) => {
                    const data = response.data.result.content;
                    this.context.commit('setConversation', data.conversation);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    get getExpenditureType() {
        return this.expenditureType;
    }
    ['setExpenditureType'](data) {
        this.expenditureType = data;
    }
    get getGeneralOptionsUOM() {
        return this.generalOptionsUOM;
    }
    ['setGeneralOptionsUOM'](data) {
        this.generalOptionsUOM = data;
    }
    get getGeneralOptionsPlant() {
        return this.generalOptionsPlant;
    }
    ['setGeneralOptionsPlant'](data) {
        this.generalOptionsPlant = data;
    }
    get getFormComment() {
        return this.formComment;
    }
    get getIsOnImportCrf() {
        return this.isOnImport;
    }
    get getIsSuccessImportedCrf() {
        return this.isSuccessImported;
    }
    get getIsGenerateClickedCrf() {
        return this.isGenerateClicked;
    }
    ['setIsOnImportCrf'](data) {
        this.isOnImport = data;
    }
    ['setIsSuccessImportedCrf'](data) {
        this.isSuccessImported = data;
    }
    ['setIsGenerateClickedCrf'](data) {
        this.isGenerateClicked = data;
    }
    ['setResetRincianInformasiItem']() {
        this.rincianInformasiArray = [
            {
                uom: '',
                isUomTouched: false,
                description: '',
                isDeskripsiTouched: false,
                currency: '',
                isCurrencyTouched: false,
                exchangeRate: '',
                estimasiBiaya: '',
                isEstimasiBiayaTouched: false,
                isSaved: false,
                quantity: '',
                isQuantityTouched: false,
                plantID: '',
                isPlantTouched: false,
                crfCreatedDate: [],
                isCrfCreatedDateTouched: false,
                periode: '',
                isIndexEdit: false,
                listSubItems: [],
                isSaveClicked: false,
                rentalType: '',
                isRentalTouched: false,
                mutationQuantity: null,
                isMutationQuantityTouched: false,
                newOrderQuantity: null,
                mutationFrom: '',
                isMutationFromTouched: false
            }
        ];
        this.errorDownloadTemplate = {};
        this.errorImportTemplate = {};
        this.isOnImport = false;
        this.isSuccessImported = false;
        this.isGenerateClicked = false;
        this.importFileCrf.files = null;
        this.importFileCrf.store = [];
        this.importFileCrf.isError = false;
        this.importFileCrf.isImported = false;
        this.importFileCrf.isAllowImport = true;
        this.listError.tabRincianInformasi = [];
    }
    ['crfImportTemplate'](params) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/item/downloadtemplate?ver=v1`;
            const payload = {
                JobTypeID: params.JobTypeID,
                TransaksiBulky: params.TransaksiBulky,
                ListLocations: params.ListLocations
            };
            return yield new Promise((resolve, reject) => {
                ApiService.postBlobFile(apiUrl, payload)
                    .then((response) => {
                    this.context.commit('setErrorDownloadTemplate', {});
                    try {
                        const fileName = response.headers['content-disposition']
                            .split('; ')[1]
                            .split('=')[1];
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                    }
                    catch (_a) {
                        const error = JSON.parse(new TextDecoder().decode(response.data));
                        const errorList = error.result.content.errorSets;
                        this.context.commit('setErrorDownloadTemplate', errorList);
                    }
                    resolve();
                })
                    .catch((error) => {
                    this.context.commit('setErrorDownloadTemplate', error);
                    reject(error);
                });
            });
        });
    }
    ['MigoImportFileCrf'](params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.importFileCrf.isOnAsync = true;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/item/importexcel?ver=v1`;
            const dataForm = new FormData();
            const payload = {
                JobTypeID: params.JobTypeID,
                TransaksiBulky: params.TransaksiBulky,
                ListLocations: params.ListLocations
            };
            dataForm.append('request', this.importFileCrf.files);
            dataForm.append('jsonData', JSON.stringify(payload));
            return yield new Promise((resolve, reject) => {
                ApiService.postImages(apiUrl, dataForm)
                    .then((response) => {
                    this.importFileCrf.isOnAsync = false;
                    this.context.commit('setIsOnImportCrf', true);
                    const res = response.data.result;
                    if (res.isError) {
                        if (res.content.data.length == 0) {
                            const errorData = {
                                statusCode: undefined,
                                message: res.content.errorSets[0].errors[0]
                            };
                            const errorItem = [];
                            res.content.errorSets.forEach((g) => {
                                let index = 0;
                                let errMessage = g.errors + ', at ' + g.field.name;
                                g.field.name = g.field.name
                                    .replace('RowNumber-', '')
                                    .split('-')
                                    .slice(1)
                                    .join('-');
                                g.errors[index] =
                                    g.field.name !== ''
                                        ? g.errors[index] + ', at ' + g.field.name
                                        : g.errors[index];
                                this.listError.tabRincianInformasi.push(g);
                                errorItem.push(errMessage);
                                index++;
                            });
                            this.context.commit('setErrorImportTemplate', errorItem);
                            this.importFileCrf.isError = true;
                            hideModal(document.getElementById('modal_import_gr_item'));
                            resolve();
                        }
                        else if (res.content.data.length > 0) {
                            this.importFileCrf.isError = true;
                            this.importFileCrf.isImported = true;
                            this.importFileCrf.isAllowImport = false;
                            const data = res.content.data;
                            let countDown = 0;
                            data.forEach((e) => {
                                countDown++;
                                store.commit('addCrfSubItemFromImport', e);
                            });
                            this.rincianInformasiArray.shift();
                            const errorItem = [];
                            res.content.errorSets.forEach((g) => {
                                let index = 0;
                                let errMessage = g.errors + ', at ' + g.field.name;
                                g.field.name = g.field.name
                                    .replace('RowNumber-', '')
                                    .split('-')
                                    .slice(1)
                                    .join('-');
                                g.errors[index] =
                                    g.field.name !== ''
                                        ? g.errors[index] + ', at ' + g.field.name
                                        : g.errors[index];
                                this.listError.tabRincianInformasi.push(g);
                                errorItem.push(errMessage);
                                index++;
                            });
                            this.context.commit('setErrorImportTemplate', errorItem);
                            hideModal(document.getElementById('modal_import_gr_item'));
                            this.context.commit('setIsSuccessImportedCrf', true);
                            resolve();
                        }
                    }
                    else {
                        this.rincianInformasiArray[0].listSubItems = [];
                        this.importFileCrf.isImported = true;
                        this.importFileCrf.isAllowImport = false;
                        const data = res.content.data;
                        let countDown = 0;
                        data.forEach((e) => {
                            countDown++;
                            store.commit('addCrfSubItemFromImport', e);
                        });
                        this.rincianInformasiArray.shift();
                        hideModal(document.getElementById('modal_import_gr_item'));
                        setTimeout(() => {
                            this.context.commit('setIsSuccessImportedCrf', true);
                        }, 1000);
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const data = {
                            statusCode: error.response.status,
                            message: error.response.statusText
                        };
                        let errorModal = [
                            {
                                errors: error.response.data.errors.request
                            }
                        ];
                        this.context.commit('setErrorDownloadTemplate', errorModal);
                        this.context.commit('setIsGenerateClickedCrf', false);
                    }
                    reject(error);
                });
            });
        });
    }
    ['addCrfSubItemFromImport'](data) {
        var _a, _b, _c;
        const obj = {
            uom: data.uom,
            isUomTouched: false,
            description: data.description,
            isDeskripsiTouched: false,
            currency: data.currency,
            isCurrencyTouched: false,
            exchangeRate: !data.exchangeRate ? '' : data.exchangeRate,
            estimasiBiaya: data.costEstimation === null
                ? null
                : ((_a = data.costEstimation.toString()) === null || _a === void 0 ? void 0 : _a.includes(',')) ? data.costEstimation
                    : data.costEstimation
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            isEstimasiBiayaTouched: false,
            isSaved: false,
            quantity: data.quantity === null
                ? null
                : ((_b = data.quantity.toString()) === null || _b === void 0 ? void 0 : _b.includes(',')) ? data.quantity
                    : data.quantity.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            isQuantityTouched: false,
            plantID: data.plantID,
            isPlantTouched: false,
            crfCreatedDate: [
                moment(data.startDate).format('DD MMM YYYY'),
                moment(data.endDate).format('DD MMM YYYY')
            ],
            isCrfCreatedDateTouched: false,
            periode: data.period,
            isIndexEdit: data.isIndexEdit,
            listSubItems: data.listSubitems !== null && Array.isArray(data.listSubitems)
                ? data.listSubitems.map((element) => {
                    var _a;
                    return ({
                        description: element.description,
                        isDescriptionTouched: true,
                        quantity: element.quantity === null
                            ? null
                            : ((_a = element.quantity.toString()) === null || _a === void 0 ? void 0 : _a.includes(',')) ? element.quantity
                                : element.quantity
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                        isQuantityTouched: true,
                        uom: data.uom,
                        isUomTouched: true,
                        code: element.code,
                        isCodeTouched: true,
                        additionalCode: element.additionalCode,
                        remarks: element.remarks
                    });
                })
                : data.listSubitems,
            isSaveClicked: false,
            rentalType: data.rentalType,
            isRentalTouched: false,
            mutationQuantity: data.mutationQuantity === null
                ? null
                : ((_c = data.mutationQuantity.toString()) === null || _c === void 0 ? void 0 : _c.includes(',')) ? data.mutationQuantity
                    : data.mutationQuantity
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            isMutationQuantityTouched: false,
            newOrderQuantity: data.newOrderQuantity,
            mutationFrom: data.mutationFrom,
            isMutationFromTouched: false
        };
        this.rincianInformasiArray.push(obj);
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setSubmitInfoMessage', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setErrorDownloadTemplate', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setErrorImportTemplate', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsAllowSubmitCrf', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setButtonIsDraftChange', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsDraftClick', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsDraftClicked', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setTabTypeFirstLand', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setWorkflowFirstLand', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setWorkflowDataStore', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setAfterCallApiCrf', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setShowMessageRincianInfoCrf', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setRincianInfoAllComplete', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setRincianInfoError', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setShowErrorDialog', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setRunWorkFlowID', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsFirstTouch', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsSubmitClicked', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsDraftJci', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsDraftFpk', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsDraft', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsSubmitLocationClicked', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsLocationTabUser', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsLocationTabDelivery', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setLocationComplete', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'addLocationUser', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'ReplaceLocationUser', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'addLocationDelivery', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'ReplaceLocationDelivery', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setContractPeriod', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setXtokenModule', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setDetailJci', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setDetailFpk', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setLookUpVendor', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setLookUpPicProc', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setDetailUser', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setLookUpFunction', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setLookUpJenisPekerjaan', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setBrrfFilesClear', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setBrrfFiles', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setFilesScopeOfWorkClear', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setFilesScopeOfWork', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setFilesPerizinanKhususClear', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setFilesPerizinanKhusus', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setHistoriesRevise', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setFilesStructureCostClear', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setFilesStructureCost', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setFilesSlaClear', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setFilesSla', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setFilesRiskAssessmentClear', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setFilesRiskAssessment', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setFilesKeteranganTambahanClear', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setFilesKeteranganTambahan', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setFilesIbprClear', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setFilesIbpr', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsLoading', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setTabConditions', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setLookUpKebutuhanPekerjaan', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setLookUpPicProcurement', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setLookUpLokasi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setLookUpLokasiPengiriman', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setLookUpPlant', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setUSDRate', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIDRRate', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setLookUpUom', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setLookUpUomPayung', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setLookUpRiskAssessment', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setLookupPerson', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'pushRincianInformasiArray', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'editIndexRincian', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setSubmitDialog', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsSubmitError', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setSuccessDialog', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setSubmitInfoDialog', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setDiscardDialog', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setImportDialogCrf', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setImportConditionCrf', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setImportFileCrf', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'deleteImportFileCrf', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setCRFTabFromFPK', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'deleteRowRincianInformasi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'editRowRincian', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'deleteRowRincianInformasiChild', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'duplicateRincianInformasiArray', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'resetState', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsHo6', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setErrorTabCrf', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setErrorTabRkk', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setErrorTabLokasi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setErrorTabRincianInformasi', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setErrorTabAdditionalInfo', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setResetErrorTab', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setResetErrorTabSpecific', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setSubmitClick', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'getXtokenModule', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'getDetailJciModule', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'getDetailFpkModule', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'getDetailUserModule', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'getLookUpFunctionModule', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'getLookUpPerson', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setConversation', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'getLookUpPersonWithSearch', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'getLookUp', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'getLookUpJenisPekerjaanModule', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'uploadFiles', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'uploadFilesTabAdditionalInfo', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'deleteFile', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'deleteFilesAdditionalInfo', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'getExchangeRateModule', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'submitCrf', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setJobTypeLabel', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'callApiDraft', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'downloadPdfCrf', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'sendChat', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'drafChangeClose', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setDraftChange', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'callApiConversation', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setExpenditureType', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setGeneralOptionsUOM', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setGeneralOptionsPlant', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsOnImportCrf', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsSuccessImportedCrf', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsGenerateClickedCrf', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setResetRincianInformasiItem', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'crfImportTemplate', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'MigoImportFileCrf', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'addCrfSubItemFromImport', null);
CrfModule = __decorate([
    Module
], CrfModule);
export default CrfModule;
